import { Button, HStack, Text, VStack } from '@chakra-ui/react'
import { useCampaignTags, useCanvasserAssignTag, useCanvasserRemoveTag } from '../../../../hooks/useCanvasser'
import { useGrantCampaign } from '../../../../hooks/useGrantCampaign'
import type { ContactDetail } from '../../../../types/contactDetail'

/** [Spec §4.7] Manual tags: remove an assigned campaign tag, add an available one. Needs a connection. */
export function TagsSection({ contactId, detail, isOnline }: { contactId: string; detail: ContactDetail; isOnline: boolean }) {
  const campaign = useGrantCampaign()
  const { data: campaignTags } = useCampaignTags(campaign?.id)
  const assignM = useCanvasserAssignTag(contactId)
  const removeM = useCanvasserRemoveTag(contactId)
  const assign = assignM.mutate
  const remove = removeM.mutate
  const busy = assignM.isPending || removeM.isPending
  const assignable = (campaignTags ?? []).filter(t => t.canBeAssigned)
  const assigned = new Set(detail.tags.map(t => t.tagId))
  const available = assignable.filter(t => !assigned.has(t.tagId))
  return (
    <VStack align="stretch" gap={2}>
      {detail.tags.length === 0 && <Text fontSize="sm" color="fg.muted">No tags yet.</Text>}
      {detail.tags.map(t => (
        <HStack key={t.id} justify="space-between" p={2} borderWidth="1px" borderColor="border" borderRadius="md">
          <Text fontSize="sm" fontWeight="medium">{t.label}</Text>
          {isOnline && assignable.some(a => a.tagId === t.tagId) && (
            <Button size="sm" minH="44px" variant="ghost" aria-label={`Remove ${t.label}`} disabled={busy} onClick={() => { if (!busy) remove(t.tagId, {}) }}>Remove</Button>
          )}
        </HStack>
      ))}
      {isOnline ? available.map(t => (
        <HStack key={t.tagId} justify="space-between" p={2} borderWidth="1px" borderColor="border" borderStyle="dashed" borderRadius="md">
          <Text fontSize="sm" color="fg.muted">{t.label}</Text>
          <Button size="sm" minH="44px" variant="ghost" aria-label={`Add ${t.label}`} disabled={busy} onClick={() => { if (!busy) assign(t.tagId, {}) }}>Add</Button>
        </HStack>
      )) : <Text fontSize="sm" color="fg.muted">Changing tags needs a connection.</Text>}
    </VStack>
  )
}
